import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { getUser } from '../../actions/session';
import { INVOICE_DOWNLOAD_API, INVOICE_LIST_API } from '../../config/rest_endpoints';
import CustomLoader from '../common/loader';
import DatePicker from "react-datepicker";
import moment from 'moment';
import Pagination from 'react-js-pagination';



const InvoiceTable = () => {
    const [tableData, setTableData] = useState([])
    const [userInfo] = useState(getUser())
    const [isGetting, setIsGetting] = useState(false)
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [isLoad, setIsLoad] = useState(false)
    const [activePage, setActivePage] = useState(1)
    const [totalCount, setTotalCount] = useState(0)
    const [itemsCount, setItemsCount] = useState(10)

    useEffect(() => {
        getInvoiceList()
    }, [])

    useEffect(() => {
        getInvoiceList()
    }, [activePage, itemsCount])

    const getInvoiceList = () => {
        let User = userInfo
        var payload = {
            "startDate": moment(startDate).startOf('day').format('MM/DD/YYYY, hh:mm:ss A'),
            "endDate": moment(endDate).endOf('day').format('MM/DD/YYYY, hh:mm:ss A')
        }
        var headers = { "Authorization": "Bearer " + User.token };
        setIsGetting(true)
        setIsLoad(true)
        Axios.post(`${INVOICE_LIST_API}/${User.id}/list?page=${activePage}&limit=${itemsCount}`, payload, { headers }).then(res => {
            if (res) {
                let resp = res.data.data
                setTableData(resp)
                if (res.data.pageinfo && res.data.pageinfo.totalCount) {
                    setTotalCount(res.data.pageinfo.totalCount)
                } else {
                    setTotalCount(0)
                }
                setIsGetting(false)
                setIsLoad(false)
            }
        }).catch(err => {
            setIsGetting(false)
            setIsLoad(false)
        })
    }

    const onDonwload = (data) => {
        const invoiceName = data.invoiceName
        const url = `${INVOICE_DOWNLOAD_API}/${invoiceName}`
        window.open(url, '_blank')
    }

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber)
    }

    const renderTableData = () => {
        if (tableData === null || tableData.length === 0) {
            return (
                <tr>
                    <td colSpan="8" className="text-center">No invoices found</td>
                </tr>
            )
        }
        else {
           return tableData.map((row,idx)=>{
                return (<tr key={idx}>
                    <td>{row['invoiceNumber']}</td>
                    <td>{row['frequency']}</td>
                    <td>{row['dateRange']}</td>
                    <td>{row['outboundMinutes']}</td>
                    <td>{row['outboundCost']}</td>
                    <td>{row['totalAmount']}</td>
                    <td>{row['createDate']}</td>
                    <td><button type="button" className="btn btn-outline-dark btn-icon border-2 ml-2" onClick={onDonwload.bind(this,row)} ><i className={'icon-file-pdf'}></i></button></td>
                </tr>)
            })
        }
    }

    return (
        <div>
            <div className="card border-left-info border-right-info">
                <div className="card-header">
                    <div className="d-flex align-items-end">
                        <div className="mr-3">
                            <label className="d-block fs-14">Start Date (UTC)</label>
                            <DatePicker
                                selected={startDate}
                                onChange={date => setStartDate(date)}
                                dateFormat="MMMM d, yyyy"
                                className="form-control"
                                maxDate={new Date()}
                            />
                        </div>
                        <div className="mr-3">
                            <label className="d-block fs-14">End Date (UTC)</label>
                            <DatePicker
                                selected={endDate}
                                onChange={date => setEndDate(date)}
                                dateFormat="MMMM d, yyyy"
                                className="form-control"
                                maxDate={new Date()}
                            />
                        </div>
                        <button className="btn btn-primary" onClick={() => { setActivePage(1); getInvoiceList(); }} disabled={isLoad}>
                            Search {isLoad ? <i className="icon-spinner2 spinner ml-2"></i> : <i className="icon-filter4 ml-2"></i>}
                        </button>
                    </div>
                </div>
                <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                    <div className="datatable-scroll">
                        <table className="table datatable-basic dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                            <thead>
                                <tr>
                                  <th>Invoice Number</th>
                                  <th>Frequency</th>
                                  <th>Date Range</th>
                                  <th>Outbound Minutes</th>
                                  <th>Outbound Cost</th>
                                  <th>Total Amount</th>
                                  <th>Created Date</th>
                                  <th>Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isGetting ? <CustomLoader colSpan={8} message="Loading invoices..." /> : renderTableData()}
                            </tbody>
                        </table>
                    </div>
                    <div className="datatable-footer">
                        <div className="d-flex justify-content-between align-items-center p-2">
                            <div className="dataTables_info" role="status" aria-live="polite">
                                Showing {tableData ? tableData.length : 0} of {totalCount}
                            </div>
                            <Pagination
                                activePage={activePage}
                                itemsCountPerPage={itemsCount}
                                totalItemsCount={totalCount}
                                pageRangeDisplayed={5}
                                onChange={handlePageChange}
                                itemClass="page-item"
                                linkClass="page-link"
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default InvoiceTable
